import React from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

interface MetersSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const MetersSearch: React.FC<MetersSearchProps> = ({
  value,
  onChange,
  placeholder = "Search meters...",
}) => {
  return (
    <div style={{ marginBottom: 16 }}>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onClear={() => onChange("")}
        prefix={<SearchOutlined />}
        allowClear
      />
    </div>
  );
};
